module.exports = __webpack_public_path__ + "static/media/TigoSportsButton.364b9f23.png";